import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SegmentoVarejoComponent } from './segmento-varejo.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';
import { ExemplosModule } from '../../components/exemplos/exemplos.module';

@NgModule({
  declarations: [
    SegmentoVarejoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    SolucoesModule,
    ExemplosModule
  ],
  exports: [
    SegmentoVarejoComponent
  ]
})

export class SegmentoVarejoModule { }
